import { ICommand, IQuery } from 'core-ts-types';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import {
  FeedbackSuggestedPlanModel,
  IFeedbackSuggestedPlanModel
} from '../../../suggestions/components/plan_feedback/models/feedback_suggested_plan_model';
import { AdvisorHeaderDetailsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';

const DEFAULT_SUGGESTION_TITLE = 'Suggest Changes';
class AdvisorHeaderEditPlan {
  private name: string;
  private createdDate: string;
  private comparingStudentPlan: boolean = false;
  private suggestedPlan: IFeedbackSuggestedPlanModel;
  private openCommentDialog: boolean = false;
  private suggestionsTitle: string = DEFAULT_SUGGESTION_TITLE;
  private openDiscardDialog: boolean = false;

  constructor(
    private ngAPStudentDetailsQuery: IQuery,
    private createEmptySuggestedPlanCommand: ICommand,
    private $state: ng.ui.IStateService,
    private ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery,
    private loadPlanFeedbackCommand: ICommand,
    private ngAPNotificationDelegate: INotificationDelegate
  ) {}

  $onInit() {
    this.name = this.ngAPStudentDetailsQuery.result.first_name;
    this.createdDate = moment().format('MMM DD, YYYY @ H:mm A');
    this.suggestedPlan = this.ngFeedbackSuggestedPlanModel.read();
    this.comparingStudentPlan = this.$state.includes('ap-advisor.plan.edit.compare');
  }

  createEmptySuggestionClicked() {
    this.createEmptySuggestedPlanCommand();
  }

  loadPlanFeedback(dialogTitle: string) {
    this.loadPlanFeedbackCommand()
      .then(() => {
        this.suggestionsTitle = dialogTitle;
        this.openCommentDialog = true;
      })
      .catch(() => {
        this.ngAPNotificationDelegate.error(`Unable to load suggestions summary.`);
      });
  }

  triggerSuggestionsDialog() {
    this.loadPlanFeedback('Suggest Changes');
  }
  triggerCommentsDialog() {
    this.loadPlanFeedback('Send Comment');
  }

  viewHistory() {
    this.$state.go('ap-advisor.changelog');
  }
  compareToggle() {
    this.$state.go(`ap-advisor.plan.edit.${this.comparingStudentPlan ? 'default' : 'compare'}`);
  }
  discardPlans() {
    this.openDiscardDialog = true;
  }
}

angular.module('capability-ng-academic-planner').component('advisorEditPlanHeader', {
  templateUrl: 'capability-ng-academic-planner/src/advisor_header/components/edit_plan/edit_plan.html',
  controller: AdvisorHeaderEditPlan
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/edit_plan/edit_plan.ts